import { apiFetcher } from '~/apis/api-fetcher';

import { SearchProductsParams, SearchProductsResponse, SearchShopProductsParams } from './models';

/** 상품 검색 */
export const searchProducts = (params: SearchProductsParams, requestInit?: RequestInit) =>
  apiFetcher.get<SearchProductsResponse>('/api/search/v6/mercari/products', params, requestInit);

/** 상점 내 상품 검색 */
export const searchShopProducts = ({ shopId, ...params }: SearchShopProductsParams, requestInit?: RequestInit) =>
  apiFetcher.get<SearchProductsResponse>(`/api/search/v6/mercari/shops/${shopId}/products`, params, requestInit);
